/**
 * Mode types
 */
export enum ModeTypes {
    fixed = 'FIXED',
    market = 'MARKET',
}
